import home from '../pages/Home.vue';
import Sense from '../pages/sense/Sense.vue';
import SenseStatus from '../pages/sense/Status.vue';
import Password from '../pages/me/edit/Password.vue';
import Name from '../pages/me/edit/Name.vue';
import Edit from '../pages/me/edit/Index.vue';
import VoteList from '../pages/forum/child/list3.vue';
import ReturnList from '../pages/shop/return/list.vue';
import ReturnDetail1 from '../pages/shop/return/detail1.vue';
import ReturnDetail2 from '../pages/shop/return/detail2.vue';
import ReturnDetail3 from '../pages/shop/return/detail3.vue';
import ReturnEdit from '../pages/shop/return/edit.vue';
import FeedBack from '../pages/feedback/Index.vue';
const imgUrl = require('@/assets/img/bg3.gif');

const list = [{
        path: '',
        meta: {
            title: "首页",
            fixed: true,
            bg: 'url(' + imgUrl + ') top center no-repeat'
        },
        component: home
    },
    {
        path: '/',
        meta: {
            title: "首页",
            fixed: true,
            bg: 'url(' + imgUrl + ')  top center no-repeat'
        },
        component: home
    },
    // bug提交页面
    {
        path: '/bug',
        meta: {
            title: "bug提交",
        },
        component: () => import('../pages/bug/index.vue')
    },
    //  meta: bg:背景色(默认白色) fixed:是否横屏 auth:是否验证登录  title浏览器的标题  toHome点击返回是否回到首页 

    {
        path: '/login',
        meta: {
            toHome: true,
            title: "登录"
        },
        component: () => import('../pages/login/login.vue')
    },
    {
        path: '/login/password',
        meta: {
            title: "找回密码"
        },
        component: () => import('../pages/login/password.vue')
    },
    {
        path: '/register',
        meta: {
            title: "注册"
        },
        component: () => import('../pages/login/register.vue')
    },
    {
        path: '/register/status',
        meta: {
            title: "注册状态"
        },
        component: () => import('../pages/login/Status.vue')
    },
    {
        path: '/register/edit',
        meta: {
            title: "设置密码"
        },
        component: Edit
    },
    {
        path: '/register/password',
        meta: {
            title: "设置密码"
        },
        component: Password
    },
    {
        path: '/register/name',
        meta: {
            title: "用户名"
        },
        component: Name
    },

    {
        path: '/recruit/sense',
        meta: {
            title: "观念匹配"
        },
        component: Sense
    },
    {
        path: '/join/sense',
        meta: {
            title: "观念匹配"
        },
        component: Sense
    },
    {
        path: '/procure/sense',
        meta: {
            title: "观念匹配"
        },
        component: Sense
    },
    {
        path: '/shop/sense',
        meta: {
            title: "观念匹配"
        },
        // component: () => import('../pages/shop/Sense.vue')
        component: Sense


    },
    {
        path: '/sense',
        meta: {
            title: "观念匹配"
        },
        component: Sense
    }, // 默认是注册用
    {
        path: '/sense/status',
        meta: {
            title: "支付状态"
        },
        component: SenseStatus
    },
    {
        path: '/assess',
        meta: {
            title: "注册"
        },
        component: () => import('../pages/sense/Assess.vue')
    },
    {
        path: '/agreement',
        meta: {
            title: "规则协议"
        },
        component: () => import('../pages/agreement/Index.vue')
    },

    //招聘
    {
        path: '/recruit',
        meta: {
            toHome: true,
            title: "招聘",
            bg: 'linear-gradient(white 100px,#F6F6F6 300px)'
        },
        component: () => import('../pages/recruit/list.vue')
    },
    {
        path: '/recruit/edit',
        meta: {
            title: "资料提交"
        },
        component: () => import('../pages/recruit/edit.vue')
    },
    {
        path: '/recruit/detail',
        meta: {
            title: "招聘详情",
            bg: 'linear-gradient(white 100px,#F6F6F6 300px)'
        },
        component: () => import('../pages/recruit/detail.vue')
    },

    {
        path: '/feedback',
        meta: {
            title: "意见反馈"
        },
        component: FeedBack
    },
    {
        path: '/images',
        meta: {
            title: "图片查看"
        },
        component: () => import('../pages/img/index.vue')
    },

    //采购
    {
        path: '/procure',
        meta: {
            toHome: true,
            title: "采购",
            bg: 'linear-gradient(white 100px,#F6F6F6 300px)'
        },
        component: () => import('../pages/procure/list.vue')
    },
    {
        path: '/procure/detail',
        meta: {
            title: "采购介绍"
        },
        component: () => import('../pages/procure/detail.vue')
    },
    {
        path: '/procure/edit',
        meta: {
            title: "资料提交",
            auth: true
        },
        component: () => import('../pages/procure/edit.vue')
    },

    //论文
    {
        path: '/paper',
        meta: {
            toHome: true,
            title: "论文",
            bg: 'linear-gradient(white 100px,#F6F6F6 300px)'
        },
        component: () => import('../pages/paper/list.vue')
    },
    {
        path: '/paper/detail',
        meta: {
            title: "查看详情"
        },
        component: () => import('../pages/paper/detail.vue')
    },
    {
        path: '/paper/edit',
        meta: {
            title: "论文提交",
            auth: true
        },
        component: () => import('../pages/paper/edit.vue')
    },
    {
        path: '/paper/score',
        meta: {
            title: "我要评分",
            auth: true
        },
        component: () => import('../pages/paper/score.vue')
    },
    {
        path: '/paper/invest',
        meta: {
            title: "注资",
            auth: true
        },
        component: () => import('../pages/paper/invest.vue')
    },
    {
        path: '/paper/status',
        meta: {
            title: "支付状态"
        },
        component: () => import('../pages/paper/status.vue')
    },
    {
        path: '/paper/list',
        meta: {
            title: "记录"
        },
        component: () => import('../pages/paper/culturelist.vue')
    },

    //法治公投
    {
        path: '/vote',
        meta: {
            toHome: true,
            title: "法治"
        },
        component: () => import('../pages/vote/list.vue')
    },
    {
        path: '/vote/case',
        meta: {
            title: "判决文书"
        },
        component: () => import('../pages/vote/case.vue')
    },
    {
        path: '/vote/plebiscite',
        meta: {
            title: "公投详情"
        },
        component: () => import('../pages/vote/plebiscite.vue')
    },
    {
        path: '/vote/plebiscite/list',
        meta: {
            title: "司法公投"
        },
        component: VoteList
    },
    {
        path: '/vote/list',
        meta: {
            title: "司法体制"
        },
        component: VoteList
    },
    {
        path: '/vote/detail',
        meta: {
            title: "查看详情"
        },
        component: () => import('../pages/vote/detail.vue')
    },
    {
        path: '/vote/edit',
        meta: {
            title: "法治公投",
            auth: true
        },
        component: () => import('../pages/vote/edit.vue')
    },
    {
        path: '/vote/score',
        meta: {
            title: "评分",
            auth: true
        },
        component: () => import('../pages/vote/score.vue')
    },
    {
        path: '/vote/invest',
        meta: {
            title: "投资",
            auth: true
        },
        component: () => import('../pages/vote/invest.vue')
    },
    {
        path: '/vote/status',
        meta: {
            title: "支付状态"
        },
        component: () => import('../pages/vote/status.vue')
    },

    //加盟
    {
        path: '/join',
        meta: {
            toHome: true,
            title: "产品加盟"
        },
        component: () => import('../pages/join/list.vue')
    },
    {
        path: '/join/detail',
        meta: {
            title: "查看详情"
        },
        component: () => import('../pages/join/detail.vue')
    },
    {
        path: '/join/edit',
        meta: {
            title: "资料提交",
            auth: true
        },
        component: () => import('../pages/join/edit.vue')
    },

    //论坛
    {
        path: '/forum',
        meta: {
            toHome: true,
            title: "论坛",
            bg: '#f7f7f7'
        },
        name: 'Forums',
        component: () => import('../pages/forum/list.vue')
    },
    {
        path: '/forum/detail',
        meta: {
            title: "查看详情"
        },
        component: () => import('../pages/forum/detail.vue')
    },
    {
        path: '/forum/edit',
        meta: {
            title: "论坛提交",
            auth: true
        },
        component: () => import('../pages/forum/edit.vue')
    },
    {
        path: '/forum/sense',
        meta: {
            title: "观念匹配"
        },
        component: () => import('../pages/forum/sense.vue')

    },
    {
        path: '/forum/edit1',
        meta: {
            title: "话题发布"
        },
        component: () => import('../pages/forum/child/edit1.vue')
    },
    {
        path: '/forum/edit2',
        meta: {
            title: "资料提交"
        },
        component: () => import('../pages/forum/child/edit2.vue')
    },
    {
        path: '/forum/edit2/date',
        meta: {
            title: "线下论坛"
        },
        component: () => import('../pages/forum/child/date.vue')
    },
    {
        path: '/forum/edit3',
        meta: {
            title: "民意调研"
        },
        component: () => import('../pages/forum/child/edit3.vue')
    },
    {
        path: '/forum/edit3/list',
        meta: {
            title: "民意调研"
        },
        component: VoteList
    },

    //个人中心
    {
        path: '/me',
        meta: {
            toHome: true,
            title: "我的主页",
            bg: '#f6f6f6'
        },
        component: () => import('../pages/me/Center.vue')
    },
    {
        path: '/me/edit',
        meta: {
            title: "个人信息",
            auth: true
        },
        component: Edit
    },
    {
        path: '/me/password',
        meta: {
            title: "修改密码",
            auth: true
        },
        component: Password
    },
    {
        path: '/me/name',
        meta: {
            title: "用户名",
            auth: true
        },
        component: Name
    },
    {
        path: '/me/msgnotify',
        meta: {
            title: "消息通知"
        },
        component: () => import('../pages/me/MsgNotify.vue')
    },
    {
        path: '/me/modulesel',
        meta: {
            title: "模块编辑",
            bg: 'linear-gradient(to bottom, #fff 0%, #F6F6F6 30%)'
        },
        component: () => import('../pages/me/ModuleSel.vue')
    },
    {
        path: '/me/buynotify',
        meta: {
            title: "采购通知"
        },
        component: () => import('../pages/me/BuyNotify.vue')
    },
    {
        path: '/me/forumnotify',
        meta: {
            title: "论坛通知"
        },
        component: () => import('../pages/me/ForumNotify.vue')
    },
    {
        path: '/me/notifydetail',
        meta: {
            title: "通知详情"
        },
        component: () => import('../pages/me/NotifyDetail.vue')
    },
    {
        path: '/me/setting',
        meta: {
            title: "设置"
        },
        component: () => import('../pages/me/Setting.vue')
    },
    {
        path: '/me/infolook',
        meta: {
            title: "个人信息"
        },
        component: () => import('../pages/me/InfoLook.vue')
    },
    {
        path: '/me/address',
        meta: {
            title: "收货地址",
            auth: true
        },
        component: () => import('../pages/me/Address.vue')
    },
    {
        path: '/me/culture',
        meta: {
            title: "我的文明"
        },
        component: () => import('../pages/me/Culture.vue')
    },
    {
        path: '/me/law',
        meta: {
            title: "我的法治",
            bg: '#f6f6f6'
        },
        name: 'MyLaw',
        component: () => import('../pages/me/Law.vue')
    },
    {
        path: '/me/fiscal',
        meta: {
            title: "我的财政"
        },
        component: () => import('../pages/me/Fiscal.vue')
    },
    {
        path: '/me/budget',
        meta: {
            title: "我的收支",
            bg:'#f6f6f6'
        },
        component: () => import('../pages/me/Budget.vue')
    },
    {
        path: '/me/join',
        meta: {
            title: "我的加盟",
            bg: '#f6f6f6'
        },
        component: () => import('../pages/me/Join.vue')
    },
    {
        path: '/me/introdetail',
        meta: {
            title: "我的介绍",
            auth: true
        },
        component: () => import('../pages/me/components/join/introdetail.vue')
    },
    {
        path: '/me/procuredetail',
        meta: {
            title: "采购详情"
        },
        component: () => import('../pages/me/components/procure/detail.vue')
    },
    {
        path: '/me/paper',
        meta: {
            title: "我的论文",
            bg: '#f6f6f6'
        },
        component: () => import('../pages/me/Paper.vue')
    },
    {
        path: '/me/forum',
        meta: {
            title: "我的论坛",
            bg: '#f6f6f6'
        },
        name: "MyForum",
        component: () => import('../pages/me/Forum.vue')
    },
    {
        path: '/me/procure',
        meta: {
            title: "我的采购",
            bg: '#f6f6f6'
        },
        component: () => import('../pages/me/Procure.vue')
    },
    {
        path: '/me/recruit',
        meta: {
            title: "我的招聘",
            bg: '#f6f6f6'
        },
        component: () => import('../pages/me/Recruit.vue')
    },

    {
        path: '/me/income',
        meta: {
            title: "我的收入"
        },
        component: () => import('../pages/me/Income.vue')
    },
    {
        path: '/me/pay',
        meta: {
            title: "我的支出",
            bg: '#f6f6f6'
        },
        component: () => import('../pages/me/Pay.vue')
    },
    {
        path: '/me/answer',
        meta: {
            title: "我的回答",
        },
        component: () => import('../pages/me/Answer.vue')
    },
    {
        path: '/me/forum/surveydetail',
        meta: {
            title: "投票详情"
        },
        component: () => import('../pages/me/components/forum/SurveyDetail.vue')
    },
    {
        path: '/aboutus',
        meta: {
            title: "关于我们"
        },
        component: () => import('../pages/me/Aboutus.vue')
    },
    {
        path: '/answer/detail',
        meta: {
            title: "我的回答",
        },
        component: () => import('../pages/me/AnswerDetail.vue')
    },
    //文明
    {
        path: '/culture',
        meta: {
            toHome: true,
            title: "文明",
            fixed: true,
            forward: true
        },
        name: "Culture",
        redirect: '/culture/cate1',
        component: () => import('../pages/culture/Index.vue'),
        children: [{
                path: '/culture/nav',
                name: "CultureNav",
                component: () => import('../pages/culture/nav.vue'),
            },
            {
                path: '/culture/cate1',
                name: "CultureCate1",
                component: () => import('../pages/culture/Cate1.vue'),
            }, {
                path: '/culture/cate2',
                name: "CultureCate2",
                component: () => import('../pages/culture/Cate2.vue'),
            }, {
                path: '/culture/cate3',
                name: "CultureCate3",
                component: () => import('../pages/culture/Cate3.vue'),
            }, {
                path: '/culture/cate4',
                name: "CultureProject",
                component: () => import('../pages/culture/project.vue'),
            },
            {
                path: '/culture/cate5',
                name: "CultureChina",
                component: () => import('../pages/culture/china.vue'),
            }
        ]
    },
    {
        path: '/culture/feedback',
        meta: {
            title: "意见反馈"
        },
        component: FeedBack /*() => import('../pages/culture/Feedback.vue')*/
    },
    {
        path: '/culture/investment',
        meta: {
            title: "注资一览",
            fixed: true
        },
        component: () => import('../pages/culture/Investment.vue')
    },
    {
        path: '/culture/myinvestment',
        meta: {
            title: "我的注资",
            fixed: true,
            bg: '#fafafa'
        },
        component: () => import('../pages/culture/MyInvestment.vue')
    },
    {
        path: '/culture/list',
        meta: {
            title: "记录",
            fixed: true
        },
        component: () => import('../pages/culture/list.vue')
    },
    // 下载APP
    {
        path: '/download',
        meta: {
            title: "下载应用"
        },
        component: () => import('../pages/download/index.vue')
    },
    // 地址详情
    {
        path: '/download/detail',
        meta: {
            title: "应用详情"
        },
        component: () => import('../pages/download/detail.vue')
    },
    //商城
    // { path: '/shop', meta:{toHome:true,title:"商城",bg:'linear-gradient(180deg, #FFFFFF 0%, #F6F6F6 100%)'}, component: () => import('../pages/show-demo/index.vue')},
    // { path: '/shop-demo/detail', meta:{title:"详情"}, component: () => import('../pages/show-demo/detail.vue') },

    {
        path: '/shop',
        meta: {
            toHome: true,
            title: "商城",
            bg: 'linear-gradient(180deg, #FFFFFF 0%, #F6F6F6 100%)'
        },
        component: () => import('../pages/shop/Index.vue'),
    },
    {
        path: '/shop/cart',
        meta: {
            title: "购物车",
            tabbar: 0
        },
        component: () => import('../pages/shop/cart.vue')
    },
    {
        path: '/shop/feedback',
        meta: {
            title: '意见反馈'
        },
        component: () => import('../pages/shop/detail/submit.vue')
    },
    {
        path: '/shop/evaluate',
        meta: {
            title: "评价"
        },
        component: () => import('../pages/shop/order/evaluate.vue')
    },
    {
        path: '/shop/order/schedule',
        meta: {
            title: "进度详情"
        },
        component: () => import('../pages/shop/order/schedule.vue')
    },
    {
        path: '/shop/comment',
        meta: {
            title: "服务评论"
        },
        component: () => import('../pages/shop/comment/index.vue')
    },
    {
        path: '/shop/comment/detail',
        meta: {
            title: "服务评论"
        },
        component: () => import('../pages/shop/comment/detail.vue')
    },
    {
        path: '/shop/comment/accidentdetail',
        meta: {
            title: "事故详情"
        },
        component: () => import('../pages/shop/comment/accidentdetail.vue')
    },
    {
        path: '/shop/trace',
        meta: {
            title: "足迹"
        },
        component: () => import('../pages/shop/Trace.vue')
    },
    {
        path: '/shop/detail',
        meta: {
            title: "详情"
        },
        component: () => import('../pages/shop/detail/index.vue')
    },
    {
        path: '/shop/order',
        meta: {
            title: "订单",
            bg: 'linear-gradient(180deg, #FFFFFF 0%, #F6F6F6 100%)',
            tabbar: 1
        },
        component: () => import('../pages/shop/order.vue')
    },
    {
        path: '/shop/order/confirm',
        meta: {
            title: "确认订单",
            bg: '#F6F6F6'
        },
        component: () => import('../pages/shop/order/index.vue')
    },
    {
        path: '/shop/order/auction',
        meta: {
            title: "拍卖确认订单",
            bg: '#F6F6F6'
        },
        component: () => import('../pages/shop/order/auctionOrder.vue')
    },
    {
        path: '/shop/order/custom',
        meta: {
            title: "发起订单",
            bg: '#F6F6F6',
            auth: true
        },
        component: () => import('../pages/shop/order/custom.vue')
    },
    {
        path: '/shop/order/survey',
        meta: {
            title: "调查报告",
            bg: '#F6F6F6'

        },
        component: () => import('../pages/shop/order/survey.vue')
    },
    {
        path: '/shop/order/logis',
        meta: {
            title: "查看物流"
        },
        component: () => import('../pages/shop/order/logis.vue')
    },
    {
        path: '/shop/order/contract',
        meta: {
            title: "查看合同"
        },
        component: () => import('../pages/shop/order/contract.vue')
    },
    {
        path: '/shop/msg1',
        meta: {
            title: "卖家消息",
            bg: 'linear-gradient(180deg, #FFFFFF 0%, #F6F6F6 20%)',
            tabbar: 2
        },
        component: () => import('../pages/shop/msg1.vue')
    },
    {
        path: '/shop/msg2',
        meta: {
            title: "系统通知",
            tabbar: 3
        },
        component: () => import('../pages/me/ForumNotify.vue')
    },
    {
        path: '/shop/msg3',
        meta: {
            title: "事故",
            bg: 'linear-gradient(180deg, #FFFFFF 0%, #F6F6F6 20%)',
            tabbar: 4
        },
        component: () => import('../pages/shop/msg3.vue')
    },
    {
        path: '/shop/accident/submit',
        meta: {
            bg: '#f6f6f6',
            title: "事故申诉提交",
        },
        component: () => import('../pages/shop/accident/index.vue')
    },
    {
        path: '/shop/accident/complaint',
        meta: {
            bg: '#f6f6f6',
            title: "查看诉呈",
        },
        component: () => import('../pages/shop/accident/Complaint.vue')
    },
    {
        path: '/shop/accident/judgment',
        meta: {
            bg: '#fff',
            title: "判决文书",
        },
        component: () => import('../pages/shop/accident/Judgment.vue')
    },
    {
        path: '/shop/accident/schedule',
        meta: {
            bg: '#fff',
            title: "事故进度",
        },
        component: () => import('../pages/shop/accident/Schedule.vue')
    },
    {
        path: '/shop/accident/returncomplete',
        meta: {
            bg: '#fff',
            title: "退货完成",
        },
        component: () => import('../pages/shop/accident/returncomplete.vue')
    },
    {
        path: '/shop/msgDetail',
        meta: {
            title: "详情",
            tabbar: 4
        },
        component: () => import('../pages/shop/msgDetail.vue')
    },
    {
        path: '/shop/collect',
        meta: {
            title: "商品收藏",
            bg: '#f8f8f8'
        },
        component: () => import('../pages/shop/collect.vue')
    },
    {
        path: '/shop/search',
        meta: {
            title: "搜索"
        },
        component: () => import('../pages/shop/search.vue')
    },

    {
        path: '/shop/return',
        meta: {
            title: "商品退货",
            bg: '#f8f8f8'
        },
        component: ReturnList
    },
    {
        path: '/shop/return/detail1',
        meta: {
            title: "申请详情"
        },
        component: ReturnDetail1
    },
    {
        path: '/shop/return/detail2',
        meta: {
            title: "损失待赔付"
        },
        component: ReturnDetail2
    },
    {
        path: '/shop/return/detail3',
        meta: {
            title: "商品退回",
            bg: '#f8f8f8'
        },
        component: ReturnDetail3
    },
    {
        path: '/shop/return/edit',
        meta: {
            title: "申请退货",
            bg: '#f8f8f8'
        },
        component: ReturnEdit
    },

    {
        path: '/shop/cancel/edit',
        meta: {
            title: "取消订单",
            bg: '#f8f8f8'
        },
        component: ReturnEdit
    },
    {
        path: '/shop/cancel/detail1',
        meta: {
            title: "订单详情",
            bg: '#f8f8f8'
        },
        component: ReturnDetail1
    },
    {
        path: '/shop/cancel/detail2',
        meta: {
            title: "损失待赔付",
            bg: '#f8f8f8'
        },
        component: ReturnDetail2
    },

    {
        path: '/address',
        meta: {
            title: "收货地址"
        },
        component: () => import('../pages/shop/address/list.vue')
    },
    {
        path: '/address/edit',
        meta: {
            title: "添加收货地址"
        },
        component: () => import('../pages/shop/address/edit.vue')
    },

    //财政
    {
        path: '/money',
        meta: {
            toHome: true,
            title: "财政"
        },
        component: () => import('../pages/money/list.vue')
    },
    {
        path: '/money/detail',
        meta: {
            title: "查询"
        },
        component: () => import('../pages/money/detail.vue')
    },

    {
        path: '/demo',
        meta: {
            toHome: true,
            title: "练习",
            fixed: false
        },
        component: () => import('../pages/demo/index.vue')
    },

    //404
    {
        path: '/:pathMatch(.*)*',
        meta: {
            toHome: true,
            title: "404"
        },
        component: () => import('../pages/404.vue')
    },

]
export default list